import React from 'react'

import Select from "react-select";
import {AffiliateQuery} from "../apollo/queries/AffiliateQuery";
import {Query} from "react-apollo";
import moment from "moment";
import {DegreesQuery} from "../apollo/queries/DegreesQuery";
import Spinner from "react-bootstrap/Spinner";
import {InstitutionsQuery} from "../apollo/queries/InstitutionsQuery";


/**
 * Root Object
 * @type {{}}
 */

/**
 * Select Options
 * @type {Array}
 */
let institutions = [];
let grades = [];

/**
 * Temporal Objects
 */


class   InscriptionForm extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      children : [],
      child: '',
      age: '',
      contactPhone: '',
      contactName: '',
      birthDate: '',
      institution: '',
      institutions: '',
      grade: '',
      affiliate: ''
    };
  }

  updateParent = () => {
    this.props.parentCallback(this.state);
  };

  handleChange = (e, label) => {
    if (label) {
      this.setState({
        [label]: e
      });
      if (label === 'child') {
        this.loadChildInfo(e.value);
      }
      if (label === 'institution') {
        if (this.state.grade) {
          this.setState({
            grade: ''
          });
        }
        this.loadGrades(e.value);
      }
    } else {
      this.setState({
        [e.target.name]: e.target.value
      })
    }

    setTimeout(
      function () {
        this.updateParent();
      }.bind(this),
      1000
    );
  };

  setError(error) {
    setTimeout(
      function () {
        this.props.errorCallBack(error);
      }.bind(this),
      500
    );
  }

  loadChildren = (institution) => {

    return (institution &&
      <Query query={AffiliateQuery} fetchPolicy={"no-cache"}
        variables={{institutionId: institution.institutionId, scheduleId: institution.scheduleId }}

        onError={(error) => {
          this.setState({
            children: []
          });
          this.setError(error)
        }}
        onCompleted={(data) => {
          this.setState({
            children: [],
            affiliate: data.affiliation
          });
          for (const index in data.affiliation.beneficiaries) {
            this.setState(prevState => ({
              children: [...prevState.children, {
                label: data.affiliation.beneficiaries[index].name + " " + data.affiliation.beneficiaries[index].lastName,
                value: data.affiliation.beneficiaries[index]
              }]
            }));
          }
        }}
      >
        {({loading, error, data}) => {
          if (loading && (!error || !data)) {
            return (
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>);
          }
          else if (this.state.children.length > 0) {
            return (
              <div>
                <br/>
                <label>Seleccione el beneficiario para realizar la inscripción</label>
                <Select options={this.state.children}
                  onChange={e => this.handleChange(e, 'child')}
                  value={this.state.child}
                />
              </div>
            )
          }
          else {
            return ( <div>
              <label>Seleccione el beneficiario para realizar la inscripción</label>
              <Select/>
            </div>)
          }
        }}
      </Query>
    )
  };

  loadGrades = (institution) => {
    return (institution &&
      <Query query={DegreesQuery} fetchPolicy={"network-only"}
        variables={{institutionId: institution.institutionId, scheduleId: institution.scheduleId}}
        onError={(error) => {
          grades = [];
          this.setError(error)
        }}
        onCompleted={(data) => {
          grades = [];
          for (const index in data.degrees) {
            grades.push({
              label: data.degrees[index].description,
              value: data.degrees[index]
            });
          }
        }}
      >
        {({loading}) => {
          if (loading) {
            return (
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>);
          }
          else if (grades.length > 0) {
            return (
              <div>
                <label>Grado de Inscripción</label>
                <Select options={grades}
                  value={this.state.grade}
                  onChange={e => this.handleChange(e, 'grade')}
                />
              </div>
            )
          }
          else {
            return ( <div>
              <label>Grado de Inscripción</label>
              <Select/>
            </div>)
          }
        }}
      </Query>
    )
  };

  loadChildInfo = (child) => {
    this.setState({
      age: child.age,
      birthDate: child.birthDate,
    });
  };

  loadData = () => {
    let institutionsAffiliate = this.state.institutions;
    institutions = [];
    for (const index in institutionsAffiliate) {
      institutions.push({
        label: institutionsAffiliate[index].name,
        value: institutionsAffiliate[index]
      });
    }
  };

  render() {
    return (
      <Query query={InstitutionsQuery} fetchPolicy={"network-only"}>
        {({loading, error, data}) => {
          if (loading) {
            return (<Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>);
          }
          if (error) {
            this.props.errorCallBack(error);
          } else {
            this.state.institutions = data.institutions;
            this.loadData();
          }

          return (
            <div>
              <label>Seleccione el Colegio en el que realizará la inscripción</label>
              <Select options={institutions}
                value={this.state.institution}
                onChange={e => this.handleChange(e, 'institution')}
              />
              {this.loadChildren(this.state.institution.value)}
              <br/>
              <div className="form-label-group">
                <label>Fecha de nacimiento del estudiante</label>
                <input type="text"
                  id="birthDate"
                  name="birthDate"
                  className="form-control"
                  placeholder="Fecha de Nacimiento"
                  value={this.state.birthDate ? moment(this.state.birthDate).utc().format("DD/MM/YYYY") : ''}
                  autoFocus
                  readOnly/>
              </div>
              <br/>
              <div className="form-label-group">
                <label>Edad</label>
                <input type="text"
                  id="age"
                  name="age"
                  className="form-control"
                  placeholder="Edad"
                  required
                  onChange={e => this.handleChange(e)}
                  value={this.state.age}
                  autoFocus
                  readOnly/>
              </div>
              <br/>
              {this.loadGrades(this.state.institution.value)}
              <hr/>
            </div>
          );
        }}
      </Query>
    )
  }
}

export default InscriptionForm;
